import { rootStateBranchSelector } from '@/packages/redux-state/store/utils/rootStateBranchSelector';

export const selectComplaintsState = rootStateBranchSelector('complaints');
